import React from 'react';
import { Row, Column } from 'react-foundation';

const Modal = (props) => {
	return (
		<div>
			<div
				className={
					props.modalState ? 'modal-window active' : 'modal-window'
				}
			>
				<Row>
					<Column small={12}>
						<div
							className={
								props.subscribed
									? 'account-card-title'
									: 'account-card-title cta'
							}
						>
							{props.subscribed
								? 'Are you sure you would like to unsubscribe?'
								: 'Subscribe now!'}
						</div>
						<div className="modal-text">
							{props.subscribed
								? 'You would be losing access to premium services'
								: ''}
						</div>
					</Column>
				</Row>
				<div className="button-holder">
					<Row>
						<Column small={12} medium={6}>
							<div
								className={
									props.subscribed
										? 'secondary-button long'
										: 'purchase-button hollow long'
								}
								onClick={props.turnOffModal}
							>
								<p>Cancel</p>
							</div>
						</Column>
						<Column small={12} medium={6}>
							<a
								className={
									props.subscribed
										? 'purchase-button black long'
										: 'purchase-button long'
								}
								href={'/accounts'}
								onClick={props.turnOffModal}
							>
								<p className="purchase-button">
									{props.subscribed
										? 'UNSUBSCRIBE'
										: 'SUBSCRIBE NOW'}
								</p>
							</a>
						</Column>
					</Row>
				</div>
				<div
					className="modal-background"
					onClick={props.turnOffModal}
				></div>
			</div>
		</div>
	);
};

export default Modal;
